import React from 'react';
import { useQuery } from '@apollo/react-hooks';

import CmsPromotionCarousel from '../../../../components/cms-promotion-carousel/cms-promotion-carousel';

import { GET_PROMOTIONS } from '../../graphql/store-detail-queries';

import './store-promos.scss';

function StorePromos() {
  const { data } = useQuery(GET_PROMOTIONS);

  const { contentSlots } = data?.cms?.page || {};
  let promoData = null;

  const typeName = 'CmsPromotionCarouselSectionComponent';

  if (contentSlots) {
    for (let section of contentSlots.reverse()) {
      const found = section?.cmsComponents?.find(
        c => c.__typename === typeName
      );
      if (found) promoData = found;
    }
  }

  return promoData ? (
    <div styleName="promos">
      <CmsPromotionCarousel {...promoData} />
    </div>
  ) : null;
}

export default StorePromos;
